


















import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({})
export default class ResultsGameCard extends Vue {
  get fluid() {
    return vxm.app.fluid;
  }

  get game() {
    return vxm.games.db[vxm.results.gameId];
  }
}
